// Verbatim content from MARKETING SUBLIME source document.
// DO NOT modify the texts.

export const CONTACT = {
  direccion: "Juan Ruiz de Alarcon 129 a int.1, Americana C.P. 44140, Guadalajara, Jalisco, México.",
  telefono: "33 3467 9950",
  telefonoTel: "+523334679950",
  email: "contacto@marketingsublime.com",
  web: "marketingsublime.com",
};

export const ABOUT = {
  p1: "Nosotros no solo creamos anuncios; diseñamos ecosistemas de marca que conectan emocionalmente con el consumidor. Somos una agencia 360° donde la estética del diseño gráfico se fusiona con la precisión del marketing digital para generar resultados tangibles. Nuestra pasión es transformar ideas en experiencias visuales y estratégicas que dominen el mercado, asegurando que cada cliente alcance su máximo potencial de visibilidad y prestigio.",
  p2: "Nacimos de la visión de un grupo de creativos decididos a romper con el marketing convencional, buscando una ejecución que fuera, precisamente, sublime. Lo que comenzó como un estudio de diseño gráfico especializado, evolucionó rápidamente al integrar estrategias de relaciones públicas y representación en medios ante la creciente demanda de nuestros clientes. Hoy, nos consolidamos como un referente de innovación, habiendo impulsado el crecimiento de diversas marcas mediante una evolución constante hacia el mundo digital y publicitario.",
};

export const MISION =
  "Impulsar el éxito de nuestros clientes mediante soluciones creativas de diseño y estrategias de marketing de alto impacto, garantizando una comunicación efectiva que potencie su presencia de marca en un entorno altamente competitivo.";

export const VISION =
  "Ser reconocidos para el 2030 como la agencia creativa más influyente de la región, liderando la transformación digital y estableciendo nuevos estándares de excelencia en publicidad y relaciones públicas a nivel internacional.";

export const SERVICIOS = [
  {
    title: "Diseño Gráfico y Branding",
    desc: "Creación de identidades visuales memorables, logotipos y manuales de identidad que transmiten la esencia y valores únicos de su empresa.",
    icon: "PenTool",
  },
  {
    title: "Marketing Digital y Social Media",
    desc: "Gestión estratégica de redes sociales, campañas de pauta (Ads), SEO y creación de contenido relevante para aumentar el engagement y las conversiones.",
    icon: "Megaphone",
  },
  {
    title: "Publicidad y Material Publicitario",
    desc: "Diseño y producción de anuncios impresos y digitales, además de artículos promocionales que mantienen su marca presente en la mente del consumidor.",
    icon: "Layers",
  },
  {
    title: "Relaciones Públicas y Representación en Medios",
    desc: "Gestión de la imagen pública y vinculación con medios de comunicación para fortalecer la reputación y el prestigio institucional de su marca.",
    icon: "Mic",
  },
  {
    title: "Producción Audiovisual y Fotografía",
    desc: "Creación de videos comerciales, fotografía de producto y contenido multimedia de alta fidelidad que eleva la calidad visual de sus campañas.",
    icon: "Camera",
  },
];

export const DISTINTIVOS = [
  {
    title: "Fusión Estratégica Integral",
    desc: "No separamos la estética de la estrategia; cada diseño nace con un objetivo de marketing claro y cada campaña digital mantiene una calidad visual impecable.",
    image: "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/pcro6cgu_fusion-estrategica.webp",
  },
  {
    title: "Personalización de Autor",
    desc: "Rechazamos las plantillas genéricas; desarrollamos piezas de comunicación únicas y personalizadas que responden específicamente a la personalidad de cada marca.",
    image: "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/dj5krx7i_personalizacion-autor.webp",
  },
  {
    title: "Enfoque en Resultados (Data-Driven)",
    desc: "Combinamos la intuición creativa con el análisis de datos para asegurar que nuestras campañas no solo sean atractivas, sino que generen conversiones reales.",
    image: "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/5ati0lp7_enfoque-resultados.webp",
  },
  {
    title: "Agilidad y Omnicanalidad",
    desc: "Tenemos la capacidad de adaptar un concepto creativo a cualquier plataforma, desde medios impresos tradicionales hasta las tendencias más recientes en redes sociales.",
    image: "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/ash087pz_agilidad.webp",
  },
  {
    title: "Acompañamiento 360°",
    desc: "Actuamos como un departamento de marketing externo para nuestros clientes, ofreciendo soporte total desde la creación del logotipo hasta la gestión de crisis en relaciones públicas.",
    image: "https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/x63j4vm2_acompanamiento.webp",
  },
];

export const KEYWORDS = [
  "Publicidad",
  "Mercado",
  "Marketing",
  "Diseño",
  "Relaciones Públicas",
  "Sublime",
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ae497e03-ec59-48fc-a251-3f544647ceb7/artifacts/wgb58vtj_Logo%20Marketing%20PNG.png";

export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_jmtvr8r",
  TEMPLATE_ID: "template_w9b73du",
  PUBLIC_KEY: "b6_pAzSd4bQvNteJn",
};
